"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IDeOrEnOrEsOrFrOrItOrNbOrNlOrPtOrRuOrZh = void 0;
var IDeOrEnOrEsOrFrOrItOrNbOrNlOrPtOrRuOrZh;
(function (IDeOrEnOrEsOrFrOrItOrNbOrNlOrPtOrRuOrZh) {
    IDeOrEnOrEsOrFrOrItOrNbOrNlOrPtOrRuOrZh["De"] = "de";
    IDeOrEnOrEsOrFrOrItOrNbOrNlOrPtOrRuOrZh["En"] = "en";
    IDeOrEnOrEsOrFrOrItOrNbOrNlOrPtOrRuOrZh["Es"] = "es";
    IDeOrEnOrEsOrFrOrItOrNbOrNlOrPtOrRuOrZh["Fr"] = "fr";
    IDeOrEnOrEsOrFrOrItOrNbOrNlOrPtOrRuOrZh["It"] = "it";
    IDeOrEnOrEsOrFrOrItOrNbOrNlOrPtOrRuOrZh["Nb"] = "nb";
    IDeOrEnOrEsOrFrOrItOrNbOrNlOrPtOrRuOrZh["Nl"] = "nl";
    IDeOrEnOrEsOrFrOrItOrNbOrNlOrPtOrRuOrZh["Pt"] = "pt";
    IDeOrEnOrEsOrFrOrItOrNbOrNlOrPtOrRuOrZh["Ru"] = "ru";
    IDeOrEnOrEsOrFrOrItOrNbOrNlOrPtOrRuOrZh["Zh"] = "zh";
})(IDeOrEnOrEsOrFrOrItOrNbOrNlOrPtOrRuOrZh || (exports.IDeOrEnOrEsOrFrOrItOrNbOrNlOrPtOrRuOrZh = IDeOrEnOrEsOrFrOrItOrNbOrNlOrPtOrRuOrZh = {}));
//# sourceMappingURL=de-or-en-or-es-or-fr-or-it-or-nb-or-nl-or-pt-or-ru-or-zh.js.map